

































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';
import Attachments from '@/components/Controls/Attachments.vue';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta',
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      logo_id: { required },
      starter_type: { required },
      name: { required },
      code: { required },
      activity_id: { required },
      rotate_ids: { },
      dry_caucity_id: { },
      temp: { },
      time_range: { },
      ph_1h_range: { },
      ph_2h_range: { },
      ph_3h_range: { },
      ph_4h_range: { },
      ph_5h_range: { },
      ph_6h_range: { },
      ph_7h_range: { },
      ph_8h_range: { },
      ph_9h_range: { },
    }

    return {
      form: rules
    }
  },
  components: {
    Attachments
  }
})
export default class StarterTypeManagerForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  document!: any
  form!: any
  loading!: any

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  rotates_enum: any[] = [
    {id: 'A', label: 'A'},
    {id: 'B', label: 'B'},
    {id: 'G', label: 'G'},
    {id: 'F', label: 'F'},
  ]
  
  get timeRange() {
    console.log('timeRange', this.form.time_range)
    return this.form.time_range ? this.form.time_range.data : [5, 10]
  }
  
  get ph1hRange() {
    return this.form.ph_1h_range ? this.form.ph_1h_range.data : [0, 7]
  }
  
  get ph2hRange() {
    return this.form.ph_2h_range ? this.form.ph_2h_range.data : [0, 7]
  }
  
  get ph3hRange() {
    return this.form.ph_3h_range ? this.form.ph_3h_range.data : [0, 7]
  }
  
  get ph4hRange() {
    return this.form.ph_4h_range ? this.form.ph_4h_range.data : [0, 7]
  }
  
  get ph5hRange() {
    return this.form.ph_5h_range ? this.form.ph_5h_range.data : [0, 7]
  }
  
  get ph6hRange() {
    return this.form.ph_6h_range ? this.form.ph_6h_range.data : [0, 7]
  }

  get ph7hRange() {
    return this.form.ph_7h_range ? this.form.ph_7h_range.data : [0, 7]
  }

  get ph8hRange() {
    return this.form.ph_8h_range ? this.form.ph_8h_range.data : [0, 7]
  }

  get ph9hRange() {
    return this.form.ph_9h_range ? this.form.ph_9h_range.data : [0, 7]
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  addAttachments(file: any) {
    this.$store.dispatch(`${STORE_KEY}/addAttachments`, {newValue: file});
  }

  removeFile( idx: number, data: any) {
    this.form.attachments.splice(idx, 1)
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

